import { IDs } from '../../../helpers/IDs';
import { getCO2Scope3StructureNachgelagert } from './getCO2Scope3Structure';

export function getCO2Scope3Auswahl(data: any, standortSelected: any, jahrVon: number, jahrBis: number) {
    if (!jahrBis) {
        jahrBis = jahrVon;
    }
    const auswahlData = data[IDs.ENT_CO2_SCOPE3_AUSWAHL];
    const keysFound: any = {};
    //  console.log('Auswahl Scope 3: ', auswahlData, standortSelected, jahrVon, jahrBis);
    auswahlData.forEach((r: any) => {
        if (
            r.jahr >= jahrVon && r.jahr <= jahrBis
            && (r.standort_tid_orig === standortSelected.tid || r.standort_tid === standortSelected.tid) && r.auswahl === 1
        ) {
            keysFound[r.name] = true;
        }
    });
    if (!keysFound.brennstoff) {
        keysFound.brennstoff = true;
    }
    if (!keysFound.emittenten) {
        keysFound.emittenten = true;
    }
    let keysAuswahl = Object.keys(keysFound);

    // WKETOOL-69: Anzahl der Kategorien
    const konfig = (data[IDs.ENT_KONFIGURATION] || [{}])[0];
    const co2Modus = konfig ? konfig.co2_fussabdruck_modus : 'ghg';
    // console.log('CO2-Modus: ', co2Modus);        
    
    const strucNacgel = getCO2Scope3StructureNachgelagert();
    keysAuswahl = keysAuswahl.filter((k: string) => {
        const fnd = strucNacgel.find((s: any) => s.key === k);
        if (fnd && fnd.hasOwnProperty('modus') && co2Modus) {
            if (fnd.modus === co2Modus) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    });
    // console.log(co2Modus, keysAuswahl);

    return keysAuswahl;
}
